import React from "react";
import { Link } from "react-router-dom";

const COLS = [
  {
    title: "Experience",
    links: [
      { label: "The Experience", to: "/experience" },
      { label: "Gallery", to: "/gallery" },
      { label: "Case Studies", to: "/case-studies" },
      { label: "Journal", to: "/journal" },
    ],
  },
  {
    title: "Occasions",
    links: [
      { label: "Luxury Weddings", to: "/event-types/luxury-weddings" },
      { label: "Corporate Events", to: "/event-types/corporate-events" },
      { label: "Embassy Receptions", to: "/event-types/embassies" },
      { label: "Museums", to: "/event-types/museums" },
    ],
  },
  {
    title: "Studio",
    links: [
      { label: "About ARIA", to: "/about" },
      { label: "FAQs", to: "/faqs" },
      { label: "Contact", to: "/contact" },
      { label: "Book ARIA", to: "/book" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-aria-ink text-aria-ivory">
      <div className="aria-container py-24 md:py-32">
        <div className="grid grid-cols-1 gap-16 md:grid-cols-12">
          <div className="md:col-span-5">
            <img src="/aria-logo-light.png" alt="ARIA — Cocktails Experience" className="h-16 w-auto md:h-20" />
            <p className="mt-8 max-w-sm font-light text-aria-ivory/60 leading-relaxed">
              A roaming cocktail experience. Handcrafted sparkling cocktails, carried through the room by hand — hospitality that comes to your guests.
            </p>
            <div className="mt-10 flex gap-8 text-[0.7rem] uppercase tracking-[0.22em] text-aria-brass">
              <span>Washington DC</span>
              <span>New York</span>
              <span>Miami</span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-10 md:col-span-7 md:grid-cols-3">
            {COLS.map((col) => (
              <div key={col.title}>
                <div className="text-[0.68rem] uppercase tracking-[0.24em] text-aria-ivory/40">{col.title}</div>
                <ul className="mt-5 space-y-3">
                  {col.links.map((l) => (
                    <li key={l.to}>
                      <Link to={l.to} className="aria-link font-display text-xl text-aria-ivory/85 hover:text-aria-ivory">
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-20 flex flex-col gap-4 border-t border-aria-ivory/10 pt-8 md:flex-row md:items-center md:justify-between">
          <p className="text-[0.7rem] uppercase tracking-[0.2em] text-aria-ivory/40">
            © {new Date().getFullYear()} ARIA — Roaming Cocktail Experience
          </p>
          <a
            href="mailto:events@ariadrinks.com"
            className="aria-link text-[0.75rem] uppercase tracking-[0.2em] text-aria-brass"
            data-testid="footer-email"
          >
            events@ariadrinks.com
          </a>
        </div>
      </div>
    </footer>
  );
}
